import React from 'react';
import {Box, Flex, Heading, Stack, Text} from '@chakra-ui/core';
import {useStateMachine} from 'little-state-machine';
import Table from 'components/Table';
import {getDisplayValues} from 'constants/dataDisplayValues';
import {parseDisplayValueInit} from 'components/ModelDetailsTable';
import {ClientDetailsForm} from 'components/ClientDetailsForm';
import {yellow} from 'styles/constants';
import RecommendedModelSimple from 'components/recommendedModelSimple';
import {SleipnerSlogan} from './step2';

const renderTableRows = (calculatedValues, valueKeys) => {
	const parseDisplayValue = parseDisplayValueInit(calculatedValues);

	return valueKeys.map((valuekey, key) => {
		const item = getDisplayValues(valuekey);
		let value = parseDisplayValue(item);

		return (
			<Box as="tr" key={key}>
				<Box as="td" p={1} px={2} h={4}>
					{item.displayText}
				</Box>
				<Box as="td" p={1} px={4} textAlign="right">
					<b>{value}</b>
				</Box>
			</Box>
		);
	});
};

export const Step3 = (props) => {
	const {state} = useStateMachine();
	const {setCurrentView, createPdf, recommendedSleipner, loading} = props;

	return (
		<Flex direction={{base: 'column', lg: 'row'}} maxW={'1400px'} margin="auto">
			<Stack
				w={{base: '100%', lg: 2 / 6}}
				mr={{base: 0, lg: 6}}
				justifyContent="space-between"
				spacing={6}
			>
				<Box>
					<Heading as="h1" mb={4} fontSize="3xl" color={yellow}>
						Client Details
					</Heading>

					<Box bg={yellow} p={6} rounded={2}>
						<Text fontSize="sm">
							If you would like to know more on the E series solutions, please leave your
							contact information below and we will get back to you.
						</Text>
						<Text fontSize="xs" my={2}>
							* You can download the PDF without having us to reach out to you
						</Text>
						<ClientDetailsForm
							setCurrentView={setCurrentView}
							createPdf={createPdf}
							loading={loading}
						/>
					</Box>

					<RecommendedModelSimple recommendedSleipner={recommendedSleipner} />
				</Box>

				<Box display={{base: 'none', lg: 'flex'}}>
					<SleipnerSlogan />
				</Box>
			</Stack>

			<Box w={{base: '100%', lg: 4 / 6}} mt={{base: 10, lg: 0}}>
				<Heading as="h1" mb={4} fontSize="3xl" color={yellow}>
					Summary
				</Heading>
				<Stack bg={yellow} p={6}>
					<Table>
						{renderTableRows(state.calculatedValues, [
							'Investment payback time (month)',
							'Increased tonnes per year',
							null,
							// "Undercarriage yearly savings",
							'Annual undercarriage rebuild part savings ($)',
							'Lifetime undercarriage rebuild savings',
							'Undercarriage related labour hours saving during lifetime ($)',
							'Undercarriage related labour hours saving during lifetime (h)',
							null,
							// "LCC cost reduction during lifetime ($)",
							'LCC cost reduction (%)',
							'LCC cost reduction ($/h)',
							'CO2 reduction with Sleipner in lifetime (tonnes)',
							'CO2 reduction with Sleipner in year (tonnes)',
							null,

							'Lifetime fuel savings ($)',
							'Yearly fuel savings ($)',
							'Fuel saved with Sleipner during lifetime (litres)',
							'Fuel saved with Sleipner in year (litres)',
							null,
							'Production increase ($)',
							'Annual increase in production (tonnes)',
							'Utilization with Sleipner (%)',
							'Utilization without Sleipner (%)',
							null,

							'Annual saved travelling time (h)',
							'Annual time spent travelling with Sleipner (%)',
							'Annual time spent travelling with Sleipner (h)',
							'Annual time spent travelling without Sleipner (h)',
						])}
					</Table>
				</Stack>
			</Box>
			<Box display={{base: 'flex', lg: 'none'}} mt={5}>
				<SleipnerSlogan />
			</Box>
		</Flex>
	);
};
